<template>
  <div class="zj-emergency-login-page" v-if="isReload">
    <div class="zj-login-form-container">
      <div class="zj-emergency-login-page-title">
        <h1>{{ CNF('app.name', '') }}</h1>
        <h2>{{ CNF('app.name_en', '') }}</h2>
        <div class="zj-emergency-login-page-title-bottom-line"></div>
      </div>
      <ZjEmergencyLoginForm
        @login="onLogin" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZjEmergencyLogin',
  data(){
    return{
      isReload:false
    }
  },
  methods: {
    // 登录成功
    onLogin(user) {
      this.$emit('login', user)
    }
  },
  created(){
    if(localStorage.getItem("action")=="logout"){
      localStorage.removeItem("action")
      return window.location.reload();
    }
    this.isReload=true;
  }
}
</script>
